import React from 'react'

import { Flex } from '@stackhouse/styled-elements'

import Modal from '@stackhouse/dashboard-components/Modal'
import Button from '@stackhouse/dashboard-components/Button'

import DataGrid from '@stackhouse/dashboard-components/DataGrid'
import { withDashboardContext } from '@stackhouse/dashboard-components/Dashboard'


const gridLayoutProps = {
    header: false,
    selectable: true,
    columns: [
        {
            key: 'label',
            label: 'Column',
            width: '40%'
        },
        {
            key: 'customLabel',
            label: 'Custom Label',
            width: '60%',
            dataType: 'text',
            editable: true
        }
    ]
}

const gridEditable = { edit: true }

const GridLayoutModal = withDashboardContext(({ close, onSave, columns, layout }) => {

    const gridRef = React.createRef()

    const rows = columns.map(column => {
        if (layout.customLabels && layout.customLabels[column.key]) {
            return { ...column, customLabel: layout.customLabels[column.key] }
        }
        return column
    })

    const initialSelected = !layout.hiddenColumns
        ? Object.keys(columns).map(Number)
        : columns.reduce((acc, inc, index) => {
            if (layout.hiddenColumns && layout.hiddenColumns.includes(inc.key)) {
                return acc
            }
            return [...acc, index]
        }, [])

    const applyLayout = (shouldSave) => {

        const [{ selectedRowIndexes, editedRows }] = gridRef.current.getState()

        const hiddenColumns = columns.reduce((acc, inc, index) => {
            if (!selectedRowIndexes.includes(index)) {
                return [...acc, inc.key]
            }
            return acc
        }, [])

        const customLabels = columns.reduce((acc, inc, index) => {
            if (editedRows[index]) {
                if (acc[inc.key] && acc[inc.key].hasOwnProperty('customLabel')) {
                    if (!editedRows[index].customLabel) {
                        delete acc[inc.key]
                        return acc
                    }
                }

                if (editedRows[index].hasOwnProperty('customLabel')) {
                    return { ...acc, [inc.key]: editedRows[index].customLabel }
                }
            }
            return acc
        }, layout.customLabels || {})

        return onSave({ customLabels, hiddenColumns }, shouldSave, close)
    }

    return (
        <Flex column justifyCenter backgroundColor={'white'} w={['33%', '100%', '50%']}>
            <DataGrid {...gridLayoutProps} ref={gridRef} rowClickEnabled={false} editable={gridEditable} rows={rows} selectedRowIndexes={initialSelected} />
            <Flex justifyEvenly p={10}>
                <Button title={'Cancel'} outline onClick={close} />
                {/*<Button title={'Apply'} onClick={() => applyLayout(false)} /> */}
                <Button title={'Apply and save'} onClick={() => applyLayout(true)} />
            </Flex>
        </Flex>
    )
}, ({ client, withLoader }) => ({ client, withLoader }))


export default ({ columns, layout, onSave }) => {
    return Modal.show(
        ({ close }) => <GridLayoutModal close={close} onSave={onSave} columns={columns} layout={layout} />,
        { position: 'right', target: 'root', animation: 'slideRight', animationTimingFunction: 'linear' }
    )
}